import { times } from 'ramda';
import { useMemo } from 'react';

export const makeLoadingIds = (quantity: number, offset = 0) => times((i) => `loading-${offset + i}`, quantity);

export const useMakeLoadingIds = (quantity: number, offset?: number) => useMemo(() => makeLoadingIds(quantity, offset), [quantity, offset]);
